import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./destinos.component.html')
})
export class DestinosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/destinos.component.ts
 **/